import { languages } from "@/i18n/settings";
import type { Locale } from "@/types";
import { getLocaleFromPath } from "./getLocaleFromPath";
import { removeLocaleFromPath } from "./removeLocaleFromPath";

export function addLocaleToPath(
  path: string,
  locale: Locale,
  primaryLocale: Locale,
  lookupFromPathIndex = 0,
) {
  const localeFromPath = getLocaleFromPath(
    path,
    languages,
    lookupFromPathIndex,
  );
  const normalizedPath = localeFromPath
    ? removeLocaleFromPath(path, localeFromPath)
    : path;

  if (locale === primaryLocale) {
    return normalizedPath;
  }

  const segmentsWithLocale = normalizedPath
    .slice(1)
    .split("/")
    .filter(Boolean)
    .toSpliced(lookupFromPathIndex, 0, locale);

  return `/${segmentsWithLocale.join("/")}/`;
}
